var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "visual_menu--section menu--section",
      class: _vm.containerClasses,
      attrs: {
        "data-section-id": _vm.section.ms_id,
        id: _vm.section.ms_id + "-MS",
        "data-menu-section-component": _vm.section.ms_custom_flipbook_component,
      },
    },
    [
      _vm._t("sectionTitleImage"),
      _vm._v(" "),
      "above-title" === _vm.contentAreaTopLayout
        ? _c("menu-content-area", {
            attrs: {
              content: _vm.section.ms_content_area_top,
              type: "section",
              position: "top",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.sectionTitle.length
        ? _c("h2", { staticClass: "menu--section_title" }, [
            _vm.isTitleBufferVisible ? _c("span") : _vm._e(),
            _vm._v(" "),
            _c("span", { domProps: { innerHTML: _vm._s(_vm.sectionTitle) } }),
            _vm._v(" "),
            _vm.isTitleBufferVisible ? _c("span") : _vm._e(),
            _vm._v(" "),
            _vm.isTitleBoxVisible
              ? _c("span", { staticClass: "menu--section_title_box" })
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.sectionMenuType.length
        ? _c("h3", {
            staticClass: "menu--section_menu_type",
            domProps: { innerHTML: _vm._s(_vm.sectionMenuType) },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.sectionMenuType.length && _vm.sectionSubtitle.length
        ? _c("h3", {
            staticClass: "menu--section_subtitle",
            domProps: { innerHTML: _vm._s(_vm.sectionSubtitle) },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.sectionMenuType.length && _vm.sectionSubtitle.length
        ? _c("h4", {
            staticClass: "menu--section_subtitle",
            domProps: { innerHTML: _vm._s(_vm.sectionSubtitle) },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.$store.state.isAdminView && _vm.section.normalizedSchedules.length
        ? _c("menu-schedules", {
            attrs: { "normalized-schedules": _vm.section.normalizedSchedules },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._t("beforeTopContentArea"),
      _vm._v(" "),
      "" === _vm.contentAreaTopLayout
        ? _c("menu-content-area", {
            attrs: {
              content: _vm.section.ms_content_area_top,
              type: "section",
              position: "top",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("menu-item-group", {
        attrs: {
          section: _vm.section,
          "menu-item-component": _vm.menuItemComponent,
          "menu-item-tag-location": _vm.menuItemTagLocation,
          layout: _vm.itemGroupLayout,
        },
      }),
      _vm._v(" "),
      ("none" !== _vm.contentAreaBottomLayout &&
        _vm.section.ms_content_area_bottom.length) ||
      _vm.section.section_tags.length
        ? _c(
            "div",
            {
              staticClass:
                "visual_menu--page_section visual_menu--page_section visual_menu--page_section-bottom",
            },
            [
              "none" !== _vm.contentAreaBottomLayout
                ? _c("menu-content-area", {
                    staticClass: "viewport",
                    attrs: {
                      content: _vm.section.ms_content_area_bottom,
                      type: "section",
                      position: "bottom",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.section.section_tags.length
                ? _c("menu-tag-legend", {
                    attrs: { tags: _vm.section.section_tags },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isTagLegendHidden && _vm.section.ms_menu_version_override
        ? _c("menu-version", {
            attrs: { version: _vm.section.ms_menu_version_override },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }